import React from 'react';
import { AlertCircle } from 'lucide-react';
interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  id: string;
}
export function FormInput({
  label,
  error,
  id,
  className = '',
  ...props
}: FormInputProps) {
  return <div className="space-y-1.5" data-id="element-45">
      <label htmlFor={id} className="block text-sm font-medium text-slate-700 transition-colors" data-id="element-46">
        {label}
      </label>
      <div className="relative" data-id="element-47">
        <input id={id} className={`
            w-full px-3 py-2.5 rounded-lg border bg-white text-slate-900 text-sm
            transition-all duration-200 ease-in-out
            placeholder:text-slate-400
            focus:outline-none focus:ring-2 focus:ring-offset-1
            disabled:opacity-50 disabled:cursor-not-allowed
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-100' : 'border-slate-200 hover:border-slate-300 focus:border-blue-500 focus:ring-blue-100'}
            ${className}
          `} {...props} data-id="element-48" />
        {error && <div className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500 pointer-events-none animate-in fade-in zoom-in duration-200" data-id="element-49">
            <AlertCircle size={16} data-id="element-50" />
          </div>}
      </div>
      {error && <p className="text-xs text-red-500 font-medium animate-in slide-in-from-top-1 duration-200" data-id="element-51">
          {error}
        </p>}
    </div>;
}